import React from 'react';

import styled from 'styled-components';

import IconMobileNavLogo from 'components/icons/mobile-nav-home';
import IconOffer from 'components/icons/offers-bk';
import IconOrder from 'components/icons/order-bk';
import IconRefresh from 'components/icons/refresh-bk';
import { routes } from 'utils/routing';

import { NavLink, iconSize } from './helpers';
import { getAboutLink, getAccountLink } from './nav-links-item';
import { IconWrap, NavLinkText } from './styled';
import { GetNavLinksParams, NavigationMobileTab } from './types';

const BrandLogo = styled(IconMobileNavLogo)<{ viewBox: string }>`
  height: 25px;
`;

const homeTextKey = 'home';
const orderTextKey = 'order';
const menuTextKey = 'menu';
const reorderTextKey = 'reorder';
const offersTextKey = 'offers';

export const getNavLinks = ({
  menuHref,
  formatMessage,
  enableAccountInFooter,
  enableOffers,
  enableStaticMenu,
}: GetNavLinksParams): NavigationMobileTab[] => {
  const navRoutes = [
    {
      selectedHrefs: [routes.base],
      Component: () => (
        <NavLink
          data-testid="home-mobile"
          to={routes.base}
          requiresExactMatch
          navBarText={homeTextKey}
        >
          <IconWrap>
            <BrandLogo viewBox="0 0 17 19" />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: homeTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [menuHref],
      Component: () => (
        <NavLink
          data-testid="order-mobile"
          to={menuHref}
          navBarText={enableStaticMenu ? menuTextKey : orderTextKey}
        >
          <IconWrap>
            <IconOrder height={iconSize} />
          </IconWrap>
          <NavLinkText>
            {formatMessage({ id: enableStaticMenu ? menuTextKey : orderTextKey })}
          </NavLinkText>
        </NavLink>
      ),
    },
    {
      selectedHrefs: [routes.orders],
      Component: () => (
        <NavLink data-testid="recent-orders-mobile" to={routes.orders} navBarText={reorderTextKey}>
          <IconWrap>
            <IconRefresh width={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: reorderTextKey })}</NavLinkText>
        </NavLink>
      ),
    },
    enableAccountInFooter ? getAccountLink({ formatMessage }) : getAboutLink({ formatMessage }),
  ];

  if (enableOffers) {
    navRoutes.splice(1, 0, {
      selectedHrefs: [routes.offers],
      Component: () => (
        <NavLink data-testid="offers-mobile" to={routes.offers} navBarText={offersTextKey}>
          <IconWrap>
            <IconOffer height={iconSize} />
          </IconWrap>
          <NavLinkText>{formatMessage({ id: offersTextKey })}</NavLinkText>
        </NavLink>
      ),
    });
  }

  return navRoutes;
};
